<!-- Marketing chrome — public pages only -->
<app-header *ngIf="shellMode === 'marketing'"></app-header>

<!-- App shell — logged-in transactional pages (engagements, admin, checkout) -->
<app-shell-header *ngIf="shellMode === 'app'"></app-shell-header>

<!-- (workspace draws its own chrome — nothing rendered here for /projects) -->

<!-- Banner -->
<div *ngIf="isOnline === false" class="offline-banner">
  ⚠️ You are offline. Your application may not work without internet.
</div>
<div *ngIf="isOnline === false" class="offline-overlay">
  <div class="message-box">
    <h2>⚡ Uh-oh! No Internet Connection ⚡</h2>
    <p>
      Your awesome Angularize experience is on pause 😎.<br />
      Reconnect to get back to building, exploring, and creating amazing things!
    </p>
    <h3>While you wait, try this:</h3>
    <h3>Play Tic Tac Toe!</h3>
    <div
      id="tic-tac-toe"
      style="
        display: grid;
        grid-template-columns: repeat(3, 100px);
        grid-gap: 5px;
        justify-content: center;
      "
    >
      <div
        *ngFor="let cell of cells; let i = index"
        (click)="makeMove(i)"
        [innerHTML]="cell"
        [ngStyle]="{
          'width.px': 100,
          'height.px': 100,
          display: 'flex',
          'align-items': 'center',
          'justify-content': 'center',
          'font-size.em': 3,
          border: '2px solid #333',
          'background-color': getCellBackgroundColor(i),
          color: getCellTextColor(i),
          'border-radius.px': 8,
          transition: '0.3s',
          'pointer-events': winner && !cells[i] ? 'none' : 'auto',
          cursor: winner && !cells[i] ? 'not-allowed' : 'pointer'
        }"
      ></div>
    </div>
    <p
      *ngIf="winner"
      style="
        padding: 20px;
        font-size: 2rem;
        font-weight: 500;
        text-align: center;
        margin-top: 20px;
        border: 1px solid #c3002f;
        border-radius: 12px;
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
        animation: pop 0.8s ease-out;
      "
    >
      {{ winnerMessage }}
    </p>
    <button mat-raised-button (click)="resetGame()" style="margin-top: 10px">
      Reset Game
    </button>
  </div>
</div>

<main [ngClass]="shellMode === 'marketing' ? 'main' : ''">
  <router-outlet></router-outlet>
</main>

<!-- Footer — marketing pages only -->
<app-footer *ngIf="shellMode === 'marketing'"></app-footer>